import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { StorageService } from "../core/storage/storage.service";

@Injectable({
  providedIn: "root",
})
export class HeaderService {
  constructor(
    private storageService: StorageService,
    private http: HttpClient
  ) {}
  getDataFromJson(section) {
    return this.http.get(`assets/json/${section}.json`);
  }
}
